import { ORGANISATION_USERS } from "../Departments/departmentsData";

export const USERS_STORAGE_KEY = "besarawak_users_v3";

const DESIGNATIONS = {
  "Jason Tan Chin Foo": "Chief Executive Officer",
  "Jacqueline Ping": "General Manager",
  "Andrea Kahar": "General Manager",
  "Joachim Soon": "General Manager",
  "Rose Bruce": "Senior Manager",
  "Candida Foo": "Executive Manager",
  "Isabella Perry": "Assistant Secretary",
  "Syazwan": "Office Driver",
  "Serena Ong": "Manager",
  "Dayang Norasyifah Binti Awang Halil": "Assistant",
  "Elisa Chai": "Manager",
  "Erica Ng": "Manager",
  "Fam Kuek Chien": "Senior Executive",
  "Nurashira Binti Muliadi": "Executive",
  "Lilyza Lagan": "Executive",
  "Sylvia Among": "Executive",
  "Chin Sin Nee": "Manager",
  "Nur Fatin Binti Ojek": "Executive",
  "Emily Bong": "Executive",
  "Nurin Jazlina": "Assistant",
  "Alex Lidu": "Office Assistant & Driver",
  "Denny Tan Yee Soon": "Senior Manager",
  "Stevenson Belawing": "Senior Executive",
  "Grace Ang Yixin": "Executive",
  "Grace Valentina Robert": "Executive",
  "Serena Sa-or": "Senior Executive",
  "Adrian Goh Sze Liang": "Manager",
  "Gloria Pahang": "Manager",
  "Azlin Peter": "Assistant",
  "John Unbang Mauga": "Manager",
  "Habibah Liza Balan": "Executive",
  "Nur Hayza Binti Hamdan": "Executive",
  "Christynn Siaw": "Manager",
  "Alexandra Sijau": "Senior Bid Designer",
  "Edna Emily Suriati Binti Gapor": "Bid Designer",
  "Dayang Adhwa' Tasnim": "Executive",
  "Bibi Alijah @ Nurannma Rozaman": "Senior Manager",
  "Myla Aron": "Manager",
  "Anne Aren Thomas": "Executive",
  "Aljjal Sienia": "Executive",
  "Ellya Emelda Rochellow": "Executive",
  "Effia Senas": "Manager",
  "Nurul Shahiha Ismail": "Executive",
  "Beatrice Stella": "Executive",
  "Alistair Lorenzo James": "Senior Executive",
  "Eric Wee": "Executive",
  "Muhamad Khairul Aizuddin": "Executive",
  "Gary Chan": "Manager",
  "Verlena Tan": "Executive",
  "Shaifullah Naim": "Designer",
  "Norul Huda": "Assistant",
};

export const DEFAULT_USERS = ORGANISATION_USERS.map((user, index) => ({
  id: `USR-${String(index + 1).padStart(3, "0")}`,
  name: user.name,
  email: user.email,
  designation: DESIGNATIONS[user.name] || (index < 5 ? "General Manager" : "Executive"),
  status: "Active",
}));

export const loadUsers = () => {
  try {
    const raw = window.localStorage.getItem(USERS_STORAGE_KEY);
    if (!raw) {
      window.localStorage.setItem(USERS_STORAGE_KEY, JSON.stringify(DEFAULT_USERS));
      return DEFAULT_USERS.map((user) => ({ ...user }));
    }
    const users = JSON.parse(raw);
    return Array.isArray(users) ? users : DEFAULT_USERS.map((user) => ({ ...user }));
  } catch (error) {
    return DEFAULT_USERS.map((user) => ({ ...user }));
  }
};

export const saveUsers = (users) => {
  try {
    window.localStorage.setItem(USERS_STORAGE_KEY, JSON.stringify(users));
  } catch (error) {
    /* Best-effort persistence for the prototype portal. */
  }
};
